import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { RoleNameField } from 'pages/Roles/components/RoleNameField';
import { RolesStatusesChipsField } from 'pages/Roles/components/RolesStatusesChipsField';
import { CreateButton } from 'shared/mui/Buttons';
import { ContextMenu, ContextMenuEditButton, ContextMenuShowButton } from 'shared/mui/ContextMenu';
import { TextField } from 'shared/react-admin/Fields';
import { ListPage } from 'shared/react-admin/Pages';
import { Permission } from 'types/embedded/permission';

import { DatagridStyled } from './RolesList.styled';
import { RolesListFilter } from './RolesListFilter';

export const RolesList: React.FC = () => {
  const { hasResourcePermissions } = usePermissions();

  return (
    <ListPage
      actions={[
        hasResourcePermissions(Resources.Roles, [Permission.Full, Permission.Create]) && (
          <CreateButton />
        ),
      ]}
      headerTitle={{ titleText: 'Роли' }}
    >
      <RolesListFilter />
      <DatagridStyled bulkActionButtons={false}>
        <TextField label="ID" sortBy="id" source="originId" />
        <RoleNameField cellClassName="column-roleName" label="Название" />
        <TextField label="Алиас" source="alias" />
        <RolesStatusesChipsField label="Статусы заказа" />
        <ContextMenu
          render={() => [
            <ContextMenuShowButton key="show_button" />,
            hasResourcePermissions(Resources.Roles, [(Permission.Full, Permission.Update)]) && (
              <ContextMenuEditButton key="edit-button" />
            ),
            hasResourcePermissions(Resources.Roles, [Permission.Full, Permission.Update]) && (
              <ContextMenuEditButton key="edit-button" />
            ),
          ]}
        />
      </DatagridStyled>
    </ListPage>
  );
};
